var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.476 1.831L1.242 11.084C0.995 11.331 0.862 11.635 0.862 11.977L0.805 14.371C0.805 14.713 0.919 15.055 1.166 15.302C1.413 15.549 1.736 15.701 2.078 15.701L4.586 15.758H4.605C4.947 15.758 5.289 15.625 5.536 15.378L14.77 6.144C15.948 4.966 15.948 3.028 14.77 1.85C13.592 0.652999 11.673 0.652999 10.476 1.831ZM2.325 14.2L2.363 12.471L4.13 14.238L2.325 14.2ZM5.403 13.364L3.256 11.217L10.248 4.225L12.395 6.372L5.403 13.364ZM13.706 5.061L13.478 5.289L11.331 3.142L11.559 2.914C12.148 2.325 13.117 2.325 13.706 2.914C14.295 3.503 14.295 4.472 13.706 5.061Z",
    fill: "#1C1C1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.97036dc8964ea01a924159814aadb6b8.svg";
export { ForwardRef as ReactComponent };